import {forEach} from "lodash";

export class ToBoothValueService {
    transformSharingPhoto(value, main, fullscreenConf,defaultLogic = true) {
        let config = main[value].digitalFormat;
        let ph = main[value].digitalFormat.photos[0];

        return {
            finalSize: {
                width: fullscreenConf.liveView.liveViewMode === "fullscreen"
                    ? fullscreenConf.general.width
                    : config.layoutWidth,
                height: fullscreenConf.liveView.liveViewMode === "fullscreen"
                    ? fullscreenConf.general.height
                    : config.layoutHeight,
            },
            internalPictureSize: {
                width: ph.width,
                height: ph.height
            },
            internalPicturePosition: {
                topX: ph.x,
                topY: ph.y
            },
            internalPictureRotation: ph.angle,
            layoutAspectRatio: {
                width: defaultLogic ? (fullscreenConf.liveView.liveViewMode === "fullscreen"
                    ? fullscreenConf.general.aspectRatio.width
                    : config.customPhotoWidth) : this.detectAspectRatioObject(fullscreenConf.general.width,fullscreenConf.general.height).w,
                height: defaultLogic ? (fullscreenConf.liveView.liveViewMode === "fullscreen"
                    ? fullscreenConf.general.aspectRatio.height
                    : config.customPhotoHeight)  : this.detectAspectRatioObject(fullscreenConf.general.width,fullscreenConf.general.height).h,
            }
        };
    }

    detectAspectRatioObject(width, height) {
        function gcd(a, b) {
            return b === 0 ? a : gcd(b, a % b);
        }

        const divisor = gcd(width, height);

        return {
            w: width / divisor,
            h: height / divisor
        };
    }

    transformPhotoAspectRatio(value, main) {
        let config = main[value];
        let transformed = {
            width: 0,
            height: 0
        };
        switch (config.photoCaptureRatio) {
            case "portrait":
                transformed.width = 2;
                transformed.height = 3;
                break;
            case "landscape":
                transformed.width = 3;
                transformed.height = 2;
                break;
            case "square":
                transformed.width = 1;
                transformed.height = 1;
                break;
            case "custom":
                transformed.width = config.customPhotoWidth;
                transformed.height = config.customPhotoHeight;
        }

        return transformed;

    }

    /**
     * View → booth: finalSize, printLayoutFormat, printDpi; internalPhotos ≥1 (fallback one frame on canvas).
     */
    transformPrintingPhotos(value, main) {
        let config = main[value];
        let photosArr = [];
        let transformed = {
            finalSize: {
                width: config.printCanvasWidth,
                height: config.printCanvasHeight
            },
            framesToPrint: 3,
            internalPhotos: [],
            activePhotoStrip: config.strip
        };

        // New fields for Android/WiFi; old Windows app ignores them
        if (config.layoutAspectRatio) {
            transformed.printLayoutFormat = config.layoutAspectRatio;
        }
        if (config.printDpi != null) {
            transformed.printDpi = config.printDpi;
        }

        if (config.strip) {
            photosArr = [...config.photosArr, ...config.strippedPhotosArr];
        } else {
            photosArr = [...config.photosArr];
        }

        forEach(photosArr, (ph) => {
            transformed.internalPhotos.push({
                size: {
                    width: ph.width,
                    height: ph.height
                },
                pos: {
                    topX: ph.x,
                    topY: ph.y
                },
                rotation: ph.angle,
                name: ph.title
            });
        });

        // Critical for Electron/FFmpeg: internalPhotos must never be empty
        if (transformed.internalPhotos.length === 0) {
            transformed.internalPhotos.push({
                pos: { topX: 0, topY: 0 },
                size: { width: config.printCanvasWidth, height: config.printCanvasHeight },
                rotation: 0,
                name: "1"
            });
        }
        return transformed;
    }

    transformStartScreenAreas(values) {
        let modes = ["single", "gif", "boomerang","video"];
        forEach(modes, (mode) => {
            if (values[mode]) {
                values[mode].x = typeof values[mode].x === "number" ? `calc(${values[mode].x}vw - ${values[mode].width/2}vh)` : 0;
                values[mode].y = typeof values[mode].y === "number" ? `calc(${values[mode].y}vh - ${values[mode].height/2}vh)` : 0;
                values[mode].width = typeof values[mode].width === "number" ?  values[mode].width + "vh" : 0;
                values[mode].height = typeof values[mode].height === "number" ? values[mode].height + "vh" : 0;
            }
        });

        return values;
    }

    transformScenes(scenes,defaultLogic = true,screen = null) {
        if (defaultLogic) {
            scenes.finalSize = {
                width: scenes.layoutWidth,
                height: scenes.layoutHeight
            };
            scenes.internalPictureSize = {
                width: scenes.photos[0].width,
                height: scenes.photos[0].height,
            };
            scenes.layoutAspectRatio = this.getSceneRatio(scenes.sceneLayoutAspectRatio, scenes.customLayoutWidth, scenes.customLayoutHeight);
            scenes.pictureAspectRatio = this.getSceneRatio(scenes.photoAspectRatio, scenes.customPhotoWidth, scenes.customPhotoHeight);
            scenes.internalPicturePosition = {
                topX: scenes.photos[0].x,
                topY: scenes.photos[0].y,
            };
            scenes.internalPictureRotation = scenes.photos[0].angle;

            delete scenes.layoutWidth;
            delete scenes.layoutHeight;
            delete scenes.photos;
            delete scenes.sceneLayoutAspectRatio;
            delete scenes.photoAspectRatio;
            delete scenes.customPhotoWidth;
            delete scenes.customPhotoHeight;
            delete scenes.customLayoutWidth;
            delete scenes.customLayoutHeight;

            forEach(scenes.scenesList, (s) => {
                s.finalSize = scenes.finalSize;
                s.internalPictureSize = scenes.internalPictureSize;
                s.layoutAspectRatio = scenes.layoutAspectRatio;
                s.pictureAspectRatio = scenes.pictureAspectRatio;
                s.internalPicturePosition = scenes.internalPicturePosition;
                s.internalPictureRotation = scenes.internalPictureRotation;

                delete s.layoutWidth;
                delete s.layoutHeight;
                delete s.photos;
                delete s.sceneLayoutAspectRatio;
                delete s.photoAspectRatio;
                delete s.customPhotoWidth;
                delete s.customPhotoHeight;
                delete s.customLayoutWidth;
                delete s.customLayoutHeight;
            });
        } else {
            scenes.finalSize = {
                width: screen.width,
                height: screen.height
            };
            scenes.internalPictureSize = {
                width: scenes.photos && scenes.photos.length>0 ? scenes.photos[0].width : screen.width,
                height: scenes.photos && scenes.photos.length>0 ? scenes.photos[0].height : screen.height,
            };
            scenes.layoutAspectRatio = this.getSceneRatio(scenes.sceneLayoutAspectRatio, scenes.customLayoutWidth, scenes.customLayoutHeight);
            scenes.pictureAspectRatio = this.getSceneRatio(scenes.photoAspectRatio, scenes.customPhotoWidth, scenes.customPhotoHeight);
            scenes.internalPicturePosition = {
                topX: 0,
                topY: 0,
            };
            scenes.internalPictureRotation = 0;

            delete scenes.layoutWidth;
            delete scenes.layoutHeight;
            delete scenes.photos;
            delete scenes.sceneLayoutAspectRatio;
            delete scenes.photoAspectRatio;
            delete scenes.customPhotoWidth;
            delete scenes.customPhotoHeight;
            delete scenes.customLayoutWidth;
            delete scenes.customLayoutHeight;

            forEach(scenes.scenesList, (s) => {
                s.finalSize = scenes.finalSize;
                s.internalPictureSize = scenes.internalPictureSize;
                s.layoutAspectRatio = scenes.layoutAspectRatio;
                s.pictureAspectRatio = scenes.pictureAspectRatio;
                s.internalPicturePosition = scenes.internalPicturePosition;
                s.internalPictureRotation = scenes.internalPictureRotation;

                delete s.layoutWidth;
                delete s.layoutHeight;
                delete s.photos;
                delete s.sceneLayoutAspectRatio;
                delete s.photoAspectRatio;
                delete s.customPhotoWidth;
                delete s.customPhotoHeight;
                delete s.customLayoutWidth;
                delete s.customLayoutHeight;
            });
        }

        return scenes;
    }

    getSceneRatio(ratio, customW, customH) {
        let transformed = {
            width: 0,
            height: 0
        };
        switch (ratio) {
            case "portrait":
                transformed.width = 2;
                transformed.height = 3;
                break;
            case "landscape":
                transformed.width = 3;
                transformed.height = 2;
                break;
            case "square":
                transformed.width = 1;
                transformed.height = 1;
                break;
            case "custom":
                transformed.width = customW;
                transformed.height = customH;
        }

        return transformed;
    }

    /**
     * Set logo style to value that can be read by booth
     */
    setLogoStyle(val) {
        const WIDTH_MULTIPLIER = 2.4;
        const MAX_SIZE = 30;

        let style = {
            width: val.size * + WIDTH_MULTIPLIER + "%",
            height: val.size + "%"
        };

        if (val.position <= 3) {
            style.top = `${5 + ((MAX_SIZE - val.size)/2)}%`;
        } else {
            style.bottom = `${5 + ((MAX_SIZE - val.size)/2)}%`;
        }

        if (val.position === 1 || val.position === 4) {
            style.left = "4%";
            style.width = val.size * (WIDTH_MULTIPLIER/2) + "%";
        } else if (val.position === 3 || val.position === 6) {
            style.right = "4%";
            style.width = val.size * (WIDTH_MULTIPLIER/2) + "%";
        } else if (val.position === 2 || val.position === 5) {
            style.left = `${50 - (val.size * (WIDTH_MULTIPLIER/2))}%`;
        }

        return style;
    }
}



// WEBPACK FOOTER //
// ./sources/services/configuration/to-booth-value.js